import { onlineIndicator } from "@/components/OnlineIndicator";
import { pushNotifications } from "./PushNotifications";
import { timerControl } from "@/components/TimerControl";
import { appNotification } from '@/components/AppNotification.js'
import { user } from '@/components/User';
import { storage } from "@/components/Storage";

export const HeaderMenuBlock = {
  controller: function (args) {
    this.time = args.time;
    this.menu = args.menu;
    const config = storage.config;
    this.isSetWebPushNotificaion = config["web_push_notification"] ?? false;
    if(this.isSetWebPushNotificaion) {
      console.log("init");
      setTimeout(() => {
        const btn = document.querySelector('[data-subscribe]')
        const {init} = pushNotifications(btn)

        init()
      })
    }
    this.isSubscribe = JSON.parse(localStorage.getItem('isSubscribe'))
  },
  view: function (ctrl) {
    return m(".fixed-header", [

      // первый этаж - синий

      m(".bg-primary", [
        m(".container[style='padding:10px;']", [
          ((appNotification.available() && (appNotification.notifications.length > 0 || appNotification.filteredNotes.length > 0))) ?
            m("i.fa.fa-exclamation-triangle", {
              onclick: function () { appNotification.load(true, true)}
            }) : '',
          m(".pull-right[style='display: flex;flex-wrap: wrap;justify-content: flex-end;']", [
            ctrl.isSetWebPushNotificaion ?
              m("button.notification-btn[style='color:#fff;margin-left:7px;cursor:pointer;'][data-subscribe]", {
                  onclick: function () {
                  }
                }, [
                  m("span.fa", { class: ctrl.isSubscribe ? 'fa-bell' : 'fa-bell-slash' }),
                  m("span[data-text]", `${ctrl.isSubscribe ? ' Активно' :` Неактивно`}`),
                ]) : "",
            ctrl.menu.map(function (item) {
              return typeof item['icon'] !== "undefined" ?
                m("a[style='color:#fff;padding-left:7px']", {
                  href: item.url,
                  config: m.route,
                  onclick: function () {}
                }, [
                  m("span.fa", { class: item.icon }),
                  m.trust("&nbsp;" + item.title)
                ]) : m("a", [])
            })
          ])
        ])
      ]),

      // второй этаж - голубой
      
      m(".cyan-header.bg-info[style='padding:5px;display:flex;align-items:center;gap:5px']", [
        m("", user.get('name')),
        m(".dateTimerControl[style='margin-left:auto']", [
          m.component(timerControl),
          m.component(onlineIndicator)
        ]),
      ])
    ])
  
  }
};
